import { render, staticRenderFns } from "./system-simulation-collection-verify.vue?vue&type=template&id=74449bc9&scoped=true"
import script from "./system-simulation-collection-verify.vue?vue&type=script&lang=js"
export * from "./system-simulation-collection-verify.vue?vue&type=script&lang=js"
import style0 from "./system-simulation-collection-verify.vue?vue&type=style&index=0&id=74449bc9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74449bc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74449bc9')) {
      api.createRecord('74449bc9', component.options)
    } else {
      api.reload('74449bc9', component.options)
    }
    module.hot.accept("./system-simulation-collection-verify.vue?vue&type=template&id=74449bc9&scoped=true", function () {
      api.rerender('74449bc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/develop-manage/system-simulation-collection-verify.vue"
export default component.exports